import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { getUserFacingApiErrorMessage } from 'core/utils/queryErrorHandling';

type QueryErrorStateProps = {
	error?: unknown;
	title?: string;
	onRetry?: () => void;
	compact?: boolean;
};

/**
 * Inline error for list/module queries — use instead of empty "No records" when isError.
 */
export function QueryErrorState({
	error,
	title = 'Unable to load data',
	onRetry,
	compact = false,
}: QueryErrorStateProps): JSX.Element {
	const message = getUserFacingApiErrorMessage(error);

	return (
		<Box
			sx={{
				p: compact ? 2 : 4,
				minHeight: compact ? undefined : 160,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: 1.5,
				textAlign: 'center',
				bgcolor: '#f8f9fa',
			}}
		>
			<Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1c1b1c' }}>
				{title}
			</Typography>
			<Typography variant="body2" color="text.secondary">
				{message}
			</Typography>
			{onRetry && (
				<Button variant="contained" onClick={onRetry} sx={{ mt: 1, textTransform: 'none' }}>
					Retry
				</Button>
			)}
		</Box>
	);
}
